import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PAiFeedbackComponent } from './p-ai-feedback.component';
import { PLikeDislikeModule } from '@panaya/ui/p-like-dislike';

@NgModule({
    imports: [CommonModule, PLikeDislikeModule],
    exports: [PAiFeedbackComponent],
    declarations: [PAiFeedbackComponent]
})
export class PAiFeedbackModule {}
